import InfoModal from "@/components/core/modals/InfoModal";
import { ROUTES } from "@/routes/Routes";
import { setSelectedOffices } from "@/state/offices/OfficesEvents";
import { UserOffice } from "@/type/core/auth/auth.types";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface OfficeInfoRowProps {
  office: UserOffice;
  setupAndOpenOrderModal: (office: UserOffice) => void;
}

const OfficeInfoRow: FunctionComponent<OfficeInfoRowProps> = ({
  office,
  setupAndOpenOrderModal,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const text =
    office.belongsToGroup && office.officeMembershipStatus === "preActivated"
      ? t("account.mySignature.certificate.qcp.groupPreActivated")
      : t("account.mySignature.certificate.qcp.credit");

  const cguAccepted = office && office.cgu;
  const isExpertComptable = office && office.expertComptable;

  if (
    office &&
    ((office.belongsToGroup && !office.qcpCertificateEnabled) ||
      office.withoutBalance)
  ) {
    // Dans le cas d'un groupe qui a désactivé la fonctionnalité on ne retourne rien
    return;
  }
  if (!cguAccepted && isExpertComptable) {
    return (
      <InfoModal
        info
        className={"ml-8"}
        onOk={() => {
          navigate(ROUTES.extranet.cgu.generate());
        }}
        value={"insufficientCreditCgu"}
      />
    );
  } else if (
    (!office?.billing?.address1 || !office.billing.zipCode) &&
    cguAccepted &&
    isExpertComptable
  ) {
    return (
      <InfoModal
        info
        className={"ml-8"}
        onOk={() => {
          setSelectedOffices([office]);
          navigate("/office#billingAddress_" + office.id);
        }}
        value={"insufficientCreditECAddress"}
      />
    );
  } else if (!cguAccepted && !isExpertComptable) {
    return (
      <InfoModal
        info
        className={"ml-8"}
        value={"insufficientCreditCollaboratorCgu"}
      />
    );
  } else if (
    (!office?.billing?.address1 || !office.billing.zipCode) &&
    cguAccepted &&
    !isExpertComptable
  ) {
    return (
      <InfoModal
        info
        className={"ml-8"}
        value={"insufficientCreditCollaboratorAddress"}
      />
    );
  } else if (
    office.belongsToGroup &&
    office.officeMembershipStatus === "preActivated"
  ) {
    return text;
  } else {
    return (
      <a className={"ml-8"} onClick={() => setupAndOpenOrderModal(office)}>
        {text}
      </a>
    );
  }
};

export default OfficeInfoRow;
